import {
  SUPPORT_CONTACT_PREFIX,
  SUPPORT_LOADING_MESSAGE,
  SUPPORT_NEUTRAL_MESSAGE,
  buildMailtoHref,
  buildTelHref,
  resolveSupportContact,
} from './supportContact';

type BrokerSupportNoticeProps = {
  supportEmail?: string | null;
  supportPhone?: string | null;
  isLoading?: boolean;
  isError?: boolean;
  className?: string;
};

/**
 * Compact support contact block shown alongside the broker selector. Shared by
 * the self-service and admin/operator target-user broker-mapping flows. It
 * renders only contacts supplied by the authenticated support-contact API and
 * has no built-in fallback contacts.
 */
export function BrokerSupportNotice({
  supportEmail = null,
  supportPhone = null,
  isLoading = false,
  isError = false,
  className = '',
}: BrokerSupportNoticeProps) {
  const contact = resolveSupportContact({
    data: { support_email: supportEmail, support_phone: supportPhone },
    isLoading,
    isError,
  });
  const baseClass = `text-2xs text-txt-muted leading-relaxed ${className}`;

  if (contact.status === 'loading') {
    return <p className={baseClass}>{SUPPORT_LOADING_MESSAGE}</p>;
  }
  if (contact.status !== 'ready') {
    return <p className={baseClass}>{SUPPORT_NEUTRAL_MESSAGE}</p>;
  }

  const telHref = contact.phone ? buildTelHref(contact.phone) : null;
  const mailHref = contact.email ? buildMailtoHref(contact.email) : null;

  return (
    <p className={baseClass}>
      {SUPPORT_CONTACT_PREFIX}
      {telHref && (
        <>
          {' · '}
          <a href={telHref} className="text-amber hover:underline whitespace-nowrap">
            {contact.phone}
          </a>
        </>
      )}
      {mailHref && (
        <>
          {' · '}
          <a href={mailHref} className="text-amber hover:underline break-all">
            {contact.email}
          </a>
        </>
      )}
    </p>
  );
}

export default BrokerSupportNotice;
